export default __webpack_public_path__ + "static/media/Loader.e29c5e7a.svg";